<template>
  <div class="wrapper">
    <div class="descredenciado-card" @click="() => $emit('show', {bloqueado, substituto})">
      <div class="description">
        <h4>{{bloqueado.nome}}</h4>
        <p>{{bloqueado.descricao_especialidade}}</p>
        <strong class="location">{{ bloqueado.bairro }} - {{bloqueado.nome_cidade}} - {{ bloqueado.id_estado }}</strong>
        <p class="red-color">Saída: {{bloqueado.data_bloqueio || 'Não informado'}}</p>
      </div>
      <div class="contact">
        <el-link class="details-btn" :underline="false">
          Ver Detalhes
          <template #icon>
            &nbsp;
            <span class="material-icons-outlined">
              chevron_right
            </span>
          </template>
        </el-link>
        <span v-if="bloqueado.telefone_primario && bloqueado.telefone_primario.replace(/\s/g, '').length > 0">
          {{bloqueado.telefone_primario}}<br/>
        </span>
        <span v-if="bloqueado.telefone_secundario && bloqueado.telefone_secundario.replace(/\s/g, '').length > 0">
          {{bloqueado.telefone_secundario}}<br/>
        </span>
        <div class="badge old">
          <span>Descredenciado</span>
          <i class="material-icons-outlined">
            block
          </i>
        </div>
      </div>
    </div>
    <div v-if="substituto" class="substituto-card" @click="() => $emit('show', {substituto})">
      <div class="icon-wrapper">
        <i class="material-icons-outlined">sync_alt</i>
      </div>
      <div class="substituto-card-wrapper">
        <div class="description">
          <h4>{{ substituto.nome }}</h4>
          <p>{{substituto.descricao_especialidade}}</p>
          <strong class="location">{{ substituto.bairro }} - {{substituto.nome_cidade}} - {{ substituto.id_estado }}</strong>
          <p class="green-color">Entrada: {{substituto.data_inicio_atendimento || 'Não informado'}}</p>
        </div>
        <div class="contact">
          <el-link class="details-btn" :underline="false">
            Ver Detalhes
            <template #icon>
              &nbsp;
              <span class="material-icons-outlined">
                chevron_right
              </span>
            </template>
          </el-link>
          <span v-if="substituto.telefone_primario && substituto.telefone_primario.replace(/\s/g, '').length > 0">
            {{substituto.telefone_primario}}<br/>
          </span>
          <span v-if="substituto.telefone_secundario && substituto.telefone_secundario.replace(/\s/g, '').length > 0">
            {{substituto.telefone_secundario}}<br/>
          </span>
          <div class="badge new">
            <span>Substituto</span>
            <i class="material-icons-outlined">
              sync_alt
            </i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DescredenciadoCard',
  props: {
    descredenciado: {
      type: Object,
      required: true
    }
  },
  computed: {
    bloqueado () {
      return this.descredenciado.bloqueado
    },
    substituto () {
      return this.descredenciado.substituto
    }
  }
}
</script>

<style scoped lang="less">
  .substituto-card-wrapper {
    display: flex;
    overflow: hidden;
    flex: 1;
    border-bottom: 1px solid #ddd;
    padding-bottom: 15px;
  }

  .descredenciado-card, .substituto-card {
    display: flex;
    padding: 15px 10px;
    overflow: hidden;
    align-items: center;
    cursor: pointer;

    h4 {
      font-size: 16px;
      font-weight: 600;
      margin: 0px;
      margin-bottom: 5px;
    }

    p {
      margin: 5px 0;
    }
  }

  .descredenciado-card {
    border-bottom: 1px solid #ddd;
  }

  .description {
    flex-grow: 1;
    padding-right: 15px;
  }

  .contact {
    width: 150px;
  }

  .details-btn, .details-btn:hover {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    color: var(--cor-texto-botao-principal);
    text-transform: uppercase;
    font-size: 12px;
    font-weight: 600;
    justify-content: flex-start;

    .material-icons-outlined {
      font-size: 18px;
    }
  }

  .red-color {
    color: #E33333;
  }

  .green-color {
    color: #09B531;
  }

  .icon-wrapper {
    background: #DDDDDD;
    color: #fff;
    border-radius: 50%;
    margin-right: 15px;
    padding: 10px;
  }

  .location {
    margin-bottom: 10px;
    display: block;
  }

  .badge {
    font-size: 11px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    overflow: hidden;
    border-radius: 15px;
    margin-top: 10px;

    &.new {
      background: #09B531;
    }

    &.old {
      background: #E33333;
    }

    span {
      flex-grow: 1;
      padding: 3px 7px 3px 7px;
      font-weight: 600;
      text-transform: uppercase;
    }

    .material-icons-outlined {
      font-size: 1.4em;
      flex: 1;
      min-width: 15px;
      max-width: 15px;
      padding: 5px;
    }
  }
</style>
